import { map, values } from 'ramda'

import { UsersById } from '@driftt/api-types'

import { createCSV } from 'utils/csv'

import { ICSATByTeammate } from './parsers'

const ensureNoNan = (value) => (value === 'NaN' ? 0 : value)

export const csatByTeammate = (
  data: ICSATByTeammate[],
  usersById: UsersById,
  filename: string
) => {
  const headers = [
    'Name',
    'Average CSAT Rating',
    'Rated Conversations',
    'Last Rated',
  ]
  const parsedData: any = map((row: ICSATByTeammate) => {
    const user = usersById[row.user] || {}
    return {
      user: user.name || user.email || 'Your teammate',
      csat: ensureNoNan(row.csat),
      convoCount: ensureNoNan(row.convoCount),
      lastRated: ensureNoNan(row.lastRated),
    }
  }, data)
  const dataWithHeaders = [
    headers,
    ...map(
      (row) => [row.user, row.csat, row.convoCount, row.lastRated],
      values(parsedData)
    ),
  ]

  createCSV(dataWithHeaders, filename)
}

export const EXPORT_FUNCTON_FOR_METRIC = Object.freeze({
  csatByTeammate: csatByTeammate,
})
